/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";
import { getSafeColor } from "services/utils";

export default styled(Drawer)(({ theme, ownerState }) => {
  const { palette, functions, breakpoints } = theme;
  const { miniSidenav, transparentSidenav } = ownerState;
  const { rgba, pxToRem } = functions;
  //  Using your Context Values
  const { sideNav } = palette;
  // SAFETY CHECK: The "Transparent" Kille

  const safeMainColor = getSafeColor(sideNav.main);

  const sidebarWidth = 220;

  return {
    "& .MuiDrawer-paper": {
      // Background uses your sideNavColor with transparency for glass effect
      background: transparentSidenav
        ? getSafeColor("transparent")
        : `${rgba(safeMainColor, 0.98)} !important`,
      backdropFilter: "none",
      WebkitBackdropFilter: "none",

      color: getSafeColor(sideNav.contrastText), // Usually #fff or your navBarTextColor
      width: sidebarWidth,
      border: "none",
      boxShadow: "none",

      //  Floating Professional Look (Desktop)
      [breakpoints.up("xl")]: {
        height: "100vh",
        margin: 0,
        borderRadius: 0,
        width: miniSidenav ? pxToRem(96) : sidebarWidth,
        // Border is a 10% invisible version of the text color
        borderRight: `1px solid ${rgba(getSafeColor(sideNav.contrastText), 0.12)}`,
      },

      // Mobile View
      [breakpoints.down("xl")]: {
        borderRadius: 0,
        height: "100vh",
        width: sidebarWidth,
        borderRight: `1px solid ${rgba(getSafeColor(sideNav.contrastText), 0.12)}`,
      },
      zIndex: 1201,

      transition: theme.transitions.create(["width", "transform"], {
        easing: theme.transitions.easeInOut,
        duration: theme.transitions.duration.standard,
      }),
    },
  };
});
